/**
 * Merges LP ExampleTeamData (schedule, averageMoneylines, logoUrl) into
 * LP ExampleGameData team objects so all GameCard windows work without Redux.
 */
import ExampleGameData from './ExampleGameData';
import ExampleTeamData from './ExampleTeamData';

const mergeTeam = (team, sport) => {
  if (!team) return team;
  const teamDataList = ExampleTeamData[sport] || [];
  const extra = teamDataList.find(t => t.teamId === team.teamId) || {};
  return {
    ...team,
    // schedule from ExampleTeamData (LP Schedule window reads team.schedule)
    schedule: extra.schedule || team.schedule || [],
    // logoUrl fallback from ExampleTeamData
    logoUrl: team.logoUrl || extra.logoUrl || '',
    // averageMoneylines for LineData window
    averageMoneylines: extra.averageMoneylines || team.averageMoneylines,
  };
};

const mergeGame = (game, sport) => {
  if (!game) return game;
  return {
    ...game,
    awayTeam: mergeTeam(game.awayTeam, sport),
    homeTeam: mergeTeam(game.homeTeam, sport),
  };
};

const MergedExampleGameData = {};
for (const sport of Object.keys(ExampleGameData)) {
  MergedExampleGameData[sport] = mergeGame(ExampleGameData[sport], sport);
}

export default MergedExampleGameData;
